import axios from 'axios';

import AuthContext from '../services/auth';
import { getEnvDetail } from '../utils/env';

const envDetail = getEnvDetail();
const instance = axios.create();

// Store reference for dispatching actions
let storeRef = null;
export const setStore = store => {
  storeRef = store;
};

// Add here the scopes to request when obtaining an access token for MS Graph API
const tokenRequest = {
  scopes: [envDetail.endpointApi],
  forceRefresh: false, // Set this to "true" to skip a cached token and go to the server to get a new token
};

// Add a request interceptor
instance.interceptors.request.use(
  config => {
    // Increment pending requests counter
    if (storeRef) {
      storeRef.dispatch({ type: 'services/common/increment_pending_requests' });
    }

    // Check and acquire a token before the request is sent
    return new Promise((resolve, reject) => {
      AuthContext.acquireTokenSilent(tokenRequest).then(token => {
        if (token) {
          config.headers.Authorization = `Bearer ${token.accessToken}`;
          resolve(config);
        } else {
          // Do something with error of acquiring the token
          reject(config);
        }
      });
    });
  },
  function(error) {
    // Decrement pending requests counter on request error
    if (storeRef) {
      storeRef.dispatch({ type: 'services/common/decrement_pending_requests' });
    }
    // Do something with error of the request
    return Promise.reject(error);
  }
);

// Add a response interceptor to decrement counter on response
instance.interceptors.response.use(
  response => {
    // Decrement pending requests counter on success
    if (storeRef) {
      storeRef.dispatch({ type: 'services/common/decrement_pending_requests' });
    }
    return response;
  },
  error => {
    // Decrement pending requests counter on error
    if (storeRef) {
      storeRef.dispatch({ type: 'services/common/decrement_pending_requests' });
    }
    return Promise.reject(error);
  }
);

export default instance;
